import { useQueryStateContext } from 'modules/queryBuilder/contexts';
import { isEmptyString } from 'utils/stringHelpers';
import { useCatalogFieldFacets } from './useCatalogFieldFacets';
import { useUserAndEventFieldFacets } from './useUserAndEventFieldFacets';
import { useCatalogName } from '../../useCatalogName';
import { ClientDataType, ESIndex } from '../../../types';

type UseFieldFacetsProps = {
  dataType: ClientDataType;
  field: string;
};

export const useFieldFacets = ({ dataType, field }: UseFieldFacetsProps) => {
  const queryState = useQueryStateContext();
  const catalogName = useCatalogName();
  const userAndEvent = useUserAndEventFieldFacets({
    dataType,
    field,
    enabled: queryState.esIndex === ESIndex.UserAndEvent,
  });
  const catalog = useCatalogFieldFacets({
    catalogName,
    field,
    enabled: queryState.esIndex === ESIndex.Catalog && !isEmptyString(catalogName),
  });

  const isLoading = userAndEvent.isLoading || catalog.isLoading;
  const didError = userAndEvent.didError || catalog.didError;
  const fieldFacets =
    queryState.esIndex === ESIndex.UserAndEvent ? userAndEvent.fieldFacets : catalog.fieldFacets;

  return {
    isLoading,
    didError,
    fieldFacets,
  };
};
